import { render, staticRenderFns } from "./MKategori.vue?vue&type=template&id=7e3e4620"
import script from "./MKategori.vue?vue&type=script&lang=js"
export * from "./MKategori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports